var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"field",attrs:{"type":"password","name":"password","rules":_vm.rs,"label":_vm.label},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})
}
var staticRenderFns = []

export { render, staticRenderFns }